import { getQueryString } from "@/utils";
import { BussinessType } from "@/utils/enum";
import { useEffect, useState } from "react";
import { loadJdPageData, loadlywlPageData } from "./service";
import { SourceDataObj, jdData, WanleData } from "./model";

export const useproductDetailHooks = () => {
    const [sourceData, setSourceData] = useState<SourceDataObj>();
    const bussinessType = Number(getQueryString('type') || 1);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    useEffect(()=>{
        loadDetailData();
    },[])

    /**加载详情数据 */
    const loadDetailData = () => {
        if (bussinessType == BussinessType.JINGDIAN){
            const dfPoiId = getQueryString('dfPoiId');
            const sceneryId = getQueryString('sceneryId');
            const param = {
                dfPoiId,
                sceneryId,
            }
            loadJdPageData(param).then(res=>{
                setIsLoading(false);
                if (res?.Data){
                    setSourceData(res?.Data);
                } else {
                    setSourceData({});
                }
            }).catch(err=>{
                setIsLoading(false);
            })
            // setSourceData(jdData);
        } else if (bussinessType === BussinessType.WANLE){
            const id = getQueryString("id");
            const dfProductId = getQueryString("dfProductId");
            const param = {
                id,
                dfProductId,
            }
            loadlywlPageData(param).then(res=>{
                setIsLoading(false);
                if (res?.Data){
                    setSourceData(res?.Data);
                } else {
                    setSourceData({});
                }
            }).catch(err=>{
                setIsLoading(false);
            })
            // setSourceData(WanleData)
        }

    }

    return {
        loadDetailData,
        sourceData,
        isLoading,
    }

}